export default "__VITE_ASSET__DQSBmUed__"